/**
 * @fileoverview 画面遷移関連
 */

import { User } from "firebase/auth";
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { SESSION_STORAGE_CREATE_ARTICLE_ID_KEY } from "./storage";

//------------
// URLパス
//------------
export const URL_PATH_PROFILE = "profile";
export const URL_PATH_ANALYSIS_DETAILS = "analysis";
export const URL_PATH_SIGN_IN = "sign-in";

//------------
// クエリパラメータ
//------------
// 遷移元特定用
export const QUERY_PARAM_NAME_FROM = "from";
export const QUERY_PARAM_VALUE_NEW = "new";
export const QUERY_PARAM_VALUE_POST = "post";
export const QUERY_PARAM_VALUE_DRAFT = "draft";

/**
 * 分析記事新規作成ページ遷移
 */
export function getCreateAnalysisUrl(
  articleId: string,
  queryName: string,
  queryValue: string
): string {
  //------------
  // 遷移先URL
  //   /me/[analysisID]?queryName=queryValue
  //------------
  return `/me/${articleId}?${queryName}=${queryValue}`;
}

/**
 * 分析投稿詳細ページURL
 */
export function getDetailAnalysisUrl(id: string): string {
  //------------
  // 遷移先URL
  //   /analysis/[id]/
  //------------
  return `/${URL_PATH_ANALYSIS_DETAILS}/${id}`;
}

/**
 * 分析投稿詳細ページURL クエリパラメータ付
 */
export function getDetailAnalysisUrlWithQuery(
  id: string,
  queryName: string,
  queryValue: string
): string {
  //------------
  // 遷移先URL
  //   /analysis/[id]?queryName=queryValue
  //------------
  const articlePath = getDetailAnalysisUrl(id);

  return `${articlePath}?${queryName}=${queryValue}`;
}

/**
 * 検索結果ページURL
 */
export function getSearchResultUrl(keyword: string): string {
  //------------
  // 遷移先URL
  //   /search/[keyword]/
  //------------
  return `/search/${keyword}`;
}

/**
 * マイページURL構築
 */
export function getMypageUrl(): string {
  //------------
  // 遷移先URL
  //   /me
  //------------
  return "/me";
}

/**
 * 下書きリスト URL構築
 */
export function getDraftListUrl(user: User): string {
  //------------
  // 遷移先URL
  //   /[userID]/draft
  //------------
  return `/${user.uid}/draft`;
}

/**
 * マイページ-プロフィール編集 URL構築
 */
export function getProfileEditUrl(): string {
  //------------
  // 遷移先URL
  //   /me/profile
  //------------
  return "/me/profile";
}

/**
 * マイページ-設定 URL構築
 */
export function getSettingsUrl(): string {
  //------------
  // 遷移先URL
  //   /[userID]/settings
  //------------
  return "/me/settings";
}

/**
 * マイページ-設定 URL構築
 */
export function getDeleteAccountConfirmUrl(): string {
  //------------
  // 遷移先URL
  //   /[userID]/settings
  //------------
  return "/me/delete_account";
}

/**
 * 分析記事作成画面遷移
 */
export function transCreateAnalysisPage(
  router: AppRouterInstance,
  articleId: string,
  from: string
) {
  //------------
  // セッションストレージ保存
  //------------
  // 対象の分析記事IDを保存
  sessionStorage.setItem(SESSION_STORAGE_CREATE_ARTICLE_ID_KEY, articleId);

  //------------
  // 遷移
  //------------
  const url = getCreateAnalysisUrl(articleId, QUERY_PARAM_NAME_FROM, from);
  router.push(url);
}

/**
 * マイページのプロフィール編集画面かどうか判定する
 */
export function isMeProfilePage() {
  return window.location.pathname.endsWith("/" + URL_PATH_PROFILE);
}
